// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewLoader_root__24F1O"};